<template>
    <div class="p-root root">
        <OFontsController/>
        <OStatisticsController/>
        <OSurveillanceController/>
        <OIntegrationEventsController/>
        <OExceptionsHandler/>
        <router-view />
        <div
            v-if="isRedirected"
            class="root__wrapper"
        >
            <h2>Incorrect URL format</h2>
        </div>
    </div>
</template>

<script>
import AButton from '@/components/atoms/a-button/a-button';
import * as Sentry from '@sentry/browser';
import {mapActions} from "vuex";
import OFontsController from "@/components/organisms/o-fonts-controller/o-fonts-controller";
import OExceptionsHandler from "@/components/organisms/o-exceptions-handler/o-exceptions-handler";
import OStatisticsController from "@/components/organisms/o-statistics-controller/o-statistics-controller";
import OSurveillanceController from "@/components/organisms/o-surveillance-controller/o-surveillance-controller";
import OIntegrationEventsController
    from "@/components/organisms/o-integration-events-controller/o-integration-events-controller";

export default {
    name: 'PRoot',
    data() {
        return {
            redirected: false
        }
    },
    components: {
        OFontsController,
        OIntegrationEventsController,
        OSurveillanceController,
        OExceptionsHandler,
        OStatisticsController,
    },
    computed: {
        isRedirected() {
            return this.$route.path === '/';
        }
    },
    methods: {
        ...mapActions([
            "registerAWSIdentity",
            "generateSessionId",
        ]),
    },
    created() {
        if(!document.location.href.includes('localhost')){
            Sentry.setTag("app-type", this.$route.name && this.$route.name.split('.')[0]);
        }

        this.registerAWSIdentity();
        this.generateSessionId();

        if(this.$route.query.ui === '0'){
            const sheet = document.createElement('style');
            sheet.innerHTML = ".ui {display: none !important;}";
            document.body.appendChild(sheet);
        }
    }
}
</script>

<style lang="scss">
@import "p-root";
</style>
